<div class="card settings-page">
  <div class="action-panel">
    @if (checkedCoverLetters.length > 0) {
      <app-button
        *appHasRole="['Admin', 'Manager']"
        id="manage-cover-letters-tags-dd"
        text="Manage Tags"
        [isDisabled]="isLoading() || addDocumentTemplateModalOpened"
        (clickBtn)="onManageTags()"
      />
    } @else {
      @if (coverLetters.length != 0) {
        <app-button
          text="Download Template"
          iconClass="icon ic-file-20"
          [isDisabled]="isLoading()"
          (clickBtn)="downloadDefaultTemplate()"
        />
      }

      <app-button
        *appHasRole="['Admin', 'Manager']"
        id="add-cover-letter-dd"
        text="Add Template"
        iconClass="icon ic-add-20"
        [isDisabled]="isLoading() || addDocumentTemplateModalOpened"
        (clickBtn)="createEditDocumentTemplate()"
      />
    }
  </div>

  <div class="card-body">
    @if (!isLoading() && coverLetters.length) {
      <app-list-grid-client-side
        [rowData]="coverLetters"
        [colDefs]="colDefs"
        [rowSelection]="documentTemplatesRowSelection"
        [suppressRowClickSelection]="true"
        [paginationPageSize]="pageSizeService.getPageSize"
        [paginationPageSizeSelector]="true"
        [suppressCellFocus]="true"
        (select)="onCoverLetterCheck($event)"
      />
    } @else if (!isLoading() && !coverLetters.length) {
      <div class="no-templates-message">
        Currently, there are no custom templates available. The default template will be used. You may <a
        (click)="createEditDocumentTemplate()">add a new template</a> or
        <a
          href="javascript:void(0)"
          (click)="downloadDefaultTemplate()"
        >download the default one</a> to proceed.
      </div>
    }

    <app-loader [loading]="isLoading()"/>
  </div>
</div>
